module.exports = __webpack_public_path__ + "img/shenfen.c9add45b.png";